import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { action } from "mobx";
import { globalVars } from "../global/GlobalVars.js";
import * as rwData from "./rwData.js";
import * as language from "./language.js";

const HandleWebSocket = observer(() => {
  useEffect(() => {
    //========================================================================
    // Konfiguration der api-Schnittstelle
    const url = window.location.hostname + ":" + window.location.port;
    const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";

    const wsUrl =
      window.location.port === "3000"
        ? `ws://${url}:${globalVars.httpPort}`
        : `${wsProtocol}://${url}/ws`;

    let socket = null;
    let reconnectTimeout = null;
    let isComponentMounted = true; // Flag für Cleanup

    // alle Updates bündeln
    const handleMessage = action((event) => {
      try {
        const wsRcvData = JSON.parse(event.data);

        switch (wsRcvData.action) {
          case "newDateTime":
            globalVars.setDateTime(wsRcvData.dateTime);
            break;
          case "updateValue":
            rwData.updateRcvValue(wsRcvData.id.toString(), wsRcvData.value);
            break;
          case "newValues":
            globalVars.setRcvValues(wsRcvData.values);
            break;
          case "activeAlarms":
            globalVars.setActiveAlarms(wsRcvData.activeAlarms);
            globalVars.setAlarmActive(wsRcvData.alarmActive);
            /*
            document.title = language.displayText(
              globalVars.pageProperties.currentPageConfig.pageTitle,
            ) +
              " (" +
              globalVars.activeAlarms.length.toString() +
              language.displayText([" Alarme)", " allarmi)", " alarms)"])
            */
            break;
          case "archivedAlarms":
            globalVars.setArchivedAlarms(wsRcvData.archivedAlarms);
            break;
          case "alarmConfig":
            globalVars.setAlarmConfig(wsRcvData.alarmConfig);
            break;
          default:
          // console.warn("Unhandled WebSocket action: ", wsRcvData.action);
        }
      } catch (error) {
        // console.error("Fehler beim Empfangen der Daten: ", error);
      }
    });

    const connectWebSocket = () => {
      if (!isComponentMounted) return;

      // Websocket-Verbindung aufbauen
      socket = new WebSocket(wsUrl);

      socket.onopen = () => {
        // console.log("WebSocket connected");
        if (isComponentMounted) {
          globalVars.setWs(socket);
        }
      };

      socket.onmessage = handleMessage;

      // Eventbehandlung
      socket.onclose = () => {
        // console.log("WebSocket disconnected");
        if (isComponentMounted) {
          globalVars.setWs(null);
          reconnectWebSocket();
        }
      };

      socket.onerror = (error) => {
        // console.error("WebSocket error: ", error);
        if (isComponentMounted) {
          globalVars.setWs(null);
          socket.close();
        }
      };
    };

    const reconnectWebSocket = () => {
      if (!isComponentMounted) return;

      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }

      reconnectTimeout = setTimeout(() => {
        if (isComponentMounted) {
          // console.log("Reconnecting WebSocket...");
          connectWebSocket();
        }
      }, 5000);
    };

    // Initiale Verbindung
    connectWebSocket();

    // Cleanup bei Unmount
    return () => {
      isComponentMounted = false;

      // Reconnect-Timeout clearen
      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
        reconnectTimeout = null;
      }

      // WebSocket aufräumen
      if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;

        // Connection schließen
        if (
          socket.readyState === WebSocket.OPEN ||
          socket.readyState === WebSocket.CONNECTING
        ) {
          socket.close();
        }

        socket = null;
      }

      // Global State clearen
      globalVars.setWs(null);
    };
  }, []);

  return null;
});

export default HandleWebSocket;
